export default __webpack_public_path__ + "static/media/dao_tools_page_icon.8f485db5.svg";